var exports = {
  "m": "BaseChangeNicknameModal.module__clearButton___c2QyWU",
};

module.exports = exports;
